import React from 'react';
import {CircularProgress} from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import {Outlet} from "react-router";
export default function LoadingDialog() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: 2
            }}
        >
            <CircularProgress />
        </Box>
    )
}
